module.exports = __webpack_public_path__ + "img/background_h.c54ff243.png";